import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { UserCheck, Lock, Sparkles, HeartHandshake, Award, MapPin, Sun } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: UserCheck,
    text: 'Atención completamente personalizada'
  }, {
    icon: Lock,
    text: 'Confidencialidad garantizada'
  }, {
    icon: Sparkles,
    text: 'Métodos energéticos especializados'
  }, {
    icon: HeartHandshake,
    text: 'Orientación clara y respetuosa'
  }, {
    icon: Award,
    text: 'Experiencia y profesionalismo'
  }, {
    icon: MapPin,
    text: 'Disponibilidad presencial y online'
  }, {
    icon: Sun,
    text: 'Resultados enfocados en bienestar y claridad personal'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 px-4 sm:px-6 lg:px-8 relative z-10 bg-mystic-black/50 border-y border-mystic-gold/10" data-id="element-42">
      <div className="max-w-7xl mx-auto" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-44">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold mb-6" data-id="element-45">
            ¿Por qué elegir{' '}
            <span className="text-gradient-gold" data-id="element-46">este servicio?</span>
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-47">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className={`glass-panel p-6 rounded-2xl flex items-start gap-4 group hover:bg-mystic-blue-800/40 transition-colors duration-300 ${index === benefits.length - 1 ? 'sm:col-span-2 lg:col-span-3 xl:col-span-1 xl:col-start-2' : ''}`} data-id="element-48">
              <div className="w-12 h-12 rounded-full bg-mystic-gold/10 flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-49">
                <benefit.icon className="w-6 h-6 text-mystic-gold" data-id="element-50" />
              </div>
              <p className="text-mystic-white/90 font-medium mt-2" data-id="element-51">
                {benefit.text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}